'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PencilEdit;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function PencilEdit(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-pencil-edit ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, d: 'M12 8.5v5.5h-10v-10h5.5l2-2h-8c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h11c0.825 0 1.5-0.675 1.5-1.5v-8l-2 2z' }),
    _react2.default.createElement('path', { fill: color, d: 'M13.5 0l-9.5 9.5v2.5h2.5l9.5-9.5c0-1.5-1-2.5-2.5-2.5z' })
  );
}

PencilEdit.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/PencilEdit/PencilEdit.js
// module id = 281
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15